module.exports = __webpack_public_path__ + "Jp_NODjpCf2_Q0OCv/RDC_RED_Logo_House.svg";